import { Injectable } from '@angular/core';
import { Cache, CacheFactory } from 'cachefactory';

@Injectable({ providedIn: 'root' })
export class ServiceViewCache {

	private _cache!: Cache;
	private cacheFactory = new CacheFactory();
	private cacheKey = 'service-cache';

	public get cache(): Cache {
		try {
			if (!this.cacheFactory.exists(this.cacheKey)) {
				this._cache = this.cacheFactory.createCache(this.cacheKey);
			}
			return this._cache;
		} catch (err) {
			throw new Error(err instanceof Error ? err.message : String(err));
		}
	}
}
